import { languageHelper } from "../../../../config/helperFunctions";


import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function InventoryReport() {
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "SN",
    },
    {
      header: languageHelper("Ingredient (Code)"),
      accessorKey: "Ingredient (Code)",
    },
    {
      header: languageHelper("Category"),
      accessorKey: "Category",
    }, {
        header: languageHelper("Stock Qty/Amount"),
        accessorKey: "Stock Qty/Amount",
      }, {
        header: languageHelper("Alert Qty/Amount"),
        accessorKey: "Alert Qty/Amount",
      },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: languageHelper("Submit"),
    },
    {
        buttonText: languageHelper("Ingredent in Alert"),
      },
  ]);

  const [selectButton] = useState([
    {
        placeholder: "Category",
      }, {
        placeholder: "Ingredent",
      }, {
        placeholder: "Food Menu",
      },
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper("Inventory")}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
     
    </main>
  );
}

export default InventoryReport;
